import { HttpClient } from '@protector/api-client';
import type { CompleteMethodology, MethodologySeasonArea } from '@protector/entities/methodology/models';
import type { UUID } from '@protector/utils/types';
import type { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { PROTECTOR_API_URL } from 'config/constants';
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';

const httpClient = new HttpClient(PROTECTOR_API_URL);

type MethodologyDetailResponse = Omit<CompleteMethodology, 'company_id' | 'default_methodology'> & {
  company_id: UUID | null;
  default_methodology: boolean | null;
};

export const getMethodologyDetailResponse = (methodologyId: UUID): AxiosObservable<CompleteMethodology> =>
  defer(() =>
    httpClient.request<MethodologyDetailResponse>({
      method: 'GET',
      url: `/api/v1/methodologies/${methodologyId}`,
      domain: 'Methodologies'
    })
  ).pipe(
    map(response => ({
      ...response,
      data: {
        ...response.data,
        company_id: response.data.company_id ?? '00000000-0000-0000-0000-000000000000',
        default_methodology: response.data.default_methodology ?? false
      }
    }))
  );

export const getMethodologyOnBase = (
  methodologyId: UUID,
  methodologyResponse$: AxiosObservable<CompleteMethodology> = getMethodologyDetailResponse(methodologyId)
): AxiosObservable<MethodologySeasonArea> =>
  methodologyResponse$.pipe(
    map(response => ({
      ...response,
      data: {
        methodologyId: response.data.id,
        companyId: response.data.company_id,
        cropId: response.data.crop_id,
        defaultMethodology: response.data.default_methodology ?? false,
        seasonIds: response.data.season_ids,
        seasonPropertyIds: response.data.season_property_ids,
        seasonAreaIds: response.data.season_area_ids
      }
    }))
  );
